import { styled } from '@mui/material/styles';

export const MainContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  object-fit: contain;
  overflow: hidden;
`;
